import { Link } from 'react-router-dom';
import { useGame } from '../hooks/use-game-definition';
import { GameId } from '../types/games';

export const FanforgeGameCard = ({ gameId }: { gameId: GameId }) => {
  const gameDefinition = useGame(gameId);

  return (
    <Link
      to={`/${gameId}`}
      key={gameId}
      className="relative rounded-[10px] overflow-hidden border border-dark-7 transition-all duration-300 ease-out group hover:border-customgreen"
    >
      <div className="absolute h-full w-full group-hover:opacity-10 bg-white opacity-0 z-10 pointer-events-none rounded-[10px] transition-opacity duration-300 ease-out" />
      <img
        className="h-full object-cover inset-1px object-center aspect-square w-full min-h-[150px] cursor-pointer"
        src={gameDefinition.metadata.logoUrl}
        alt={gameDefinition.metadata.displayName}
      />
      <div className="absolute w-[calc(100%-16px)] left-2 bottom-2 flex flex-row flex-grow justify-between gap-2 px-2 py-2 bg-customdarkgray rounded-lg shadow-[0_1px_4px_0_rgba(0,_0,_0,_0.40)]">
        <div className="flex flex-col items-start justify-between gap-1 mt-auto">
          <p className="text-white text-xs font-bold">{gameDefinition.metadata.displayName}</p>
          <div className="flex items-center gap-1 text-customgray text-[8px]">
            <span>{gameDefinition.metadata.multiplayer ? 'Multiplayer' : 'Singleplayer'}</span>
            <div className="w-[1.75px] h-[1.75px] rounded-full bg-customgray" />
            <span>{gameDefinition.metadata.genre}</span>
          </div>
        </div>
        <div className="flex min-w-6 w-6 h-6 justify-center items-center rounded-3xl bg-customgreen shadow-green-inset">
          <img
            src="images/icons/play.svg"
            alt="Play Icon"
            className="transform transition duration-300 ease-out group-hover:scale-[1.15]"
          />
        </div>
      </div>
    </Link>
  );
};
